module.exports = "<div class=\"loading\">\n  <div class=\"lds-ellipsis\">\n    <div></div>\n    <div></div>\n    <div></div>\n    <div></div>\n  </div>\n</div>"